<template>
  <div class="edu_pages_content_body_box">
    <div class="edu_table_box">
      <el-table
        :data="resData.list"
        height="100%"
        :header-cell-style="{ background: '#DDE4FF', color: '#474859' }"
        class="table_box"
      >
        <el-table-column prop="id" label="序号" width="70" align="center">
          <template slot-scope="scope">
            {{ reqData.pageSize * (reqData.pageNum - 1) + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="headline"
          label="标题"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="message"
          label="消息内容"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="identification" label="消息类型" align="center">
          <template slot-scope="scope">
            {{ scope.row.identification == 1 ? "教育局" : "学校" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="timestamp"
          label="发送时间"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ $Common.dateFormatDateTwo(scope.row.timestamp) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-link type="primary" @click="checkClick(scope.row)" :underline="false"
              >查看状态</el-link
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="edu_pagination_box" v-if="resData.total > 0">
      <el-pagination
        @current-change="handleCurrentChange"
        background
        :current-page="reqData.pageNum"
        :page-size="reqData.pageSize"
        layout="total, prev, pager, next, jumper"
        :total="resData.total"
      >
      </el-pagination>
    </div>
    <notices-list :noticesResize="noticesResize" :selObj="selObj"></notices-list>
  </div>
</template>
<script>
import noticesList from "./noticesList.vue";
export default {
  name: "",
  components: {
    noticesList,
  },
  props: {
    identification: {
      type: Number,
      default: {
        return: 1,
      },
    },
  },
  data() {
    return {
      eduInfo: JSON.parse(sessionStorage.getItem("eduInfo")),
      activeIndex: "1",
      reqData: {
        senderId: this.$store.getters.getEduData.eduId,
        identification: 1,
        pageNum: 1,
        pageSize: 20,
      },
      resData: {
        pageSize: 0,
        pageNum: 0,
        total: 0,
        pages: 0,
        list: [],
      },
      addResize: 0,
      addType: "school",
      noticesResize: 0,
      selObj: {
        identification: "",
        notificationId: "",
      },
    };
  },
  watch: {
    identification: function (newVal) {
      if (newVal) {
        // let eduId = this.$store.getters.getEduData.eduId;
        // this.getSubEduList(eduId);
        this.reqData.identification = newVal;
        this.getList();
      }
    },
  },
  computed: {},
  methods: {
    clearData() {
      this.actionDataInfo = {
        eduId: this.$store.getters.getEduData.eduId,
        title: "",
        startTime: "",
        endTime: "",
        projectIds: "",
        inspectionTeamIds: "",
      };
    },
    checkClick(item) {
      // console.log(item, 11111);
      this.selObj = item;
      this.noticesResize++;
      // this.$Common.updateNoticesStatus(item.notificationId, 2);
    },
    cancelForm() {
      this.actionDataBox = false;
      this.$refs.ruleForm.resetFields();
      this.clearData();
    },
    handleCurrentChange(val) {
      this.reqData.pageNum = val;
      console.log(`当前页: ${val}`);
      this.getDataList();
    },

    getList() {
      this.reqData.pageNum = 1;
      this.getDataList();
    },
    async getDataList() {
      let res = await this.$Http.getEduNoticesList(this.reqData);
      if (res.code == 200) {
        this.resData.pageSize = res.data.pageSize;
        this.resData.pageNum = res.data.pageNum;
        this.resData.total = res.data.total;
        this.resData.pages = res.data.pages;
        this.resData.list = res.data.list;
      } else if (res.code == 101) {
        this.resData.total = 0;
        this.resData.list = [];
      } else {
        this.$message({
          message: res.messsage,
          type: "error",
        });
      }
    },
  },
  created() {
    this.getDataList();
  },
  mounted() {},
};
</script>
<style scoped lang="scss">
@import "../../../../../../public/css/edu_pages.scss";
.el-menu-item {
  height: 50px !important;
  line-height: 50px !important;
}
</style>
